import { useState, useEffect } from 'react';
import { Modal, Spinner } from 'bv-components';
import withLazyLoad from 'bv-lazy-load';
import { getJSON } from 'bv-fetch';

const OccupationAndSalaryApp = withLazyLoad(<Spinner />)(
  'occupationAndSalary',
);

const getRequiresOccupationForm = () => getJSON('/api/occupation_and_salary/requires_form');

const OccupationAndSalary = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    getRequiresOccupationForm()
      .then((data) => {
        setEnabled(data);
      })
      .catch(() => setEnabled(false));
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <Modal icon={false}>
      <OccupationAndSalaryApp
        onSuccessModalClose={() => setEnabled(false)}
        contactUsVisible={false}
      />
    </Modal>
  );
};

export default OccupationAndSalary;
